import React, { FunctionComponent } from "react";
import StepsRouter from "./router";
import "./index.css";
import LayoutContainer from "../../containers/Layout";

const App: FunctionComponent<{}> = () => (
  <LayoutContainer>
    <StepsRouter />
  </LayoutContainer>
);

export default App;
